import { IconButton } from "@mui/material";
import { Drawer } from "@mui/material";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

type SidebarListitemProps = {
  is_loading: boolean;
};

type MainScreenProps = {
  has_footer: boolean;
};

export const Wrapper = styled(Drawer)(() => ({
  "& .MuiDrawer-paper": {
    background: "transparent",
    boxShadow: "none",
    display: "flex",
    flexDirection: "row",
  },
}));

export const Sidebar = styled("section")(() => ({
  height: "calc(100% - 30px)",
  width: "15vw",
  maxWidth: 220,
  marginTop: 15,
  background: "white",
  borderRadius: 8,
  padding: "2rem",
  marginRight: 5,
}));

export const SidebarTitle = styled("div")(() => ({
  marginBottom: 26,
  color: "#465869",
  letterSpacing: "0.1em",
  "& span": {
    font: "600 12px/14px Manrope",
  },
}));

export const SidebarList = styled("ul")(() => ({
  listStyle: "none",
  paddingLeft: "none",
  "& li": {
    font: "700 16px/24px Manrope",
    color: "#93A9BD",
    cursor: "pointer",
    "&:not(:last-child)": {
      marginBottom: 28,
    },
    "&.active": {
      color: "#465869",
    },
  },
}));

export const SidebarListItem = styled("li", {
  shouldForwardProp: (prop) => prop !== "is_loading",
})<SidebarListitemProps>(({ is_loading }) => ({
  cursor: !is_loading ? "pointer !important" : "default !important",
}));

export const SidebarButtonsWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: 16,
  marginTop: 40,
}));
export const SidebarButtonText = styled("span")(() => ({
  font: "700 14px/24px Manrope",
  marginLeft: 12,
}));

export const Main = styled("section")(() => ({
  height: "calc(100% - 30px)",
  width: "70vw",
  marginTop: 15,
  background: "white",
  borderRadius: 8,
  marginRight: 15,
  "@media (max-width: 1024px)": {
    width: "65vw",
  },
  "@media (max-width: 768px)": {
    width: "60vw",
  },
}));

export const MainHeader = styled("header")(() => ({
  background: "#EDF5FB",
  borderRadius: "8px 8px 0 0",
  height: 80,
  padding: "14px 24px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

export const MainFooter = styled("footer")(() => ({
  alignItems: "center",
  background: "#EDF5FB",
  borderRadius: "0 0 8px 8px",
  bottom: "15px",
  display: "flex",
  height: 80,
  justifyContent: "space-between",
  padding: "14px 24px",
  position: "absolute",
  width: "70vw",
}));

export const MainHeaderTitle = styled("span")(() => ({
  font: "700 16px/24px Manrope",
  color: "#308CDB",
}));

export const MainHeaderSubtitle = styled("span")(() => ({
  font: "400 14px/20px Manrope",
  color: "#344054",
}));

export const MainHeaderToggle = styled(IconButton)(() => ({
  background: "#fff",
  width: 24,
  height: 24,
  fontSize: 16,
  color: "#308CDB !important",
  padding: 0,
}));

export const MainScreen = styled("section", {
  shouldForwardProp: (prop) => prop !== "has_footer",
})<MainScreenProps>(({ has_footer }) => ({
  maxHeight: `calc(100% - ${has_footer ? "160" : "80"}px)`,
  overflowY: "auto",
}));

export const MainTitle = styled("p")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "22px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "28px",

  backgroundColor: "#F9FAFB",
  padding: "12px 24px",
}));

export const MainComponent = styled("div")(() => ({
  padding: "0 24px 24px 24px",
}));
